/**
 * İsim - Soyisim gibi verileri Türkçe karakter kuralına göre "Title Case" formatına çevirir.
 * Örn: "sİnAn iPEK" -> "Sinan İpek"
 */
export function formatFullName(name?: string | null): string {
  if (!name) return ''

  const lowers = name.toLocaleLowerCase('tr-TR')
  return lowers
    .split(' ')
    .filter(Boolean)
    .map((word) => {
      return word.charAt(0).toLocaleUpperCase('tr-TR') + word.slice(1)
    })
    .join(' ')
}

/**
 * Uzun isimleri profil ekranı header'ında sıkışmaması için kısaltır.
 * Yalnızca 3+ kelimeli ve 20 karakteri aşan isimlerde kısaltma uygular.
 * 2 kelimeli isimler tam gösterilir (CSS truncate taşmayı halleder).
 * Örn: "Emel İptalleriyle Ünlü" -> "Emel İ. Ü."
 * Örn: "Test Kullanıcısı" -> "Test Kullanıcısı" (değişmez)
 */
export function formatHeaderName(name?: string | null): string {
  const formatted = formatFullName(name)
  if (!formatted) return ''

  const parts = formatted.split(' ')
  if (parts.length >= 3 && formatted.length > 20) {
    const firstPart = parts.shift()
    const initials = parts.map(p => p.charAt(0) + '.')
    return `${firstPart} ${initials.join(' ')}`
  }
  return formatted
}

